import { ajax } from './api';
import type { WorldBoxDto } from 'cadenza/api-client/dto/world-box-dto';

export function getSuggestedExtent (layerId: string, srsCode: string): Promise<WorldBoxDto> {
  return ajax(`/layers/${layerId}/suggestedextent`, { data: { srsCode } });
}
